import React, { useState, useEffect, useMemo } from "react";
import styles from "./EscalationsPage.module.css";
import Card from "shared/Card";
import PendingSuspensionItem from "./PendingSuspensionItem";
import EscalatedIncidentItem from "./EscalatedIncidentItem";
import EscalatedIncidentsModal from "./EscalatedIncidentsModal";
import SuspendUserModal from "./SuspendUserModal";
import PaginationControls from "shared/PaginationControls";
import { useEscalations, useSuspendUser } from "./useEscalations";

import getPaginatedList from "../IncidentsPage/utils/getPaginatedList";

export function EscalationsPage() {
  let resultsPerPage = 7;
  const { data, status, refetch } = useEscalations("incidents");
  const suspendUser = useSuspendUser();

  const [escalatedModalOpen, setEscalatedModalOpen] = useState(false);
  const [suspendModalOpen, setSuspendModalOpen] = useState(false);

  const [escalationData, setEscalationData] = useState([]);
  const [suspensionData, setSuspensionData] = useState([]);
  const [incidentItem, setIncidentItem] = useState([]);

  const [currentSuspensionList, setCurrentSuspensionList] = useState([]);
  const [suspensionPage, setSuspensionPage] = useState(1);
  const suspensionMaxPages = useMemo(
    () =>
      suspensionData ? Math.ceil(suspensionData.length / resultsPerPage) : 1,
    [suspensionData]
  );

  const [currentEscalationList, setCurrentEscalationList] = useState([]);
  const [escalationPage, setEscalationPage] = useState(1);
  const escalationMaxPages = useMemo(
    () =>
      escalationData ? Math.ceil(escalationData.length / resultsPerPage) : 1,
    [escalationData]
  );

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (data) {
      const sortedData = data.filter((item) => {
        return (
          item.pendingSuspension &&
          item.pendingSuspension.platforms &&
          item.pendingSuspension.platforms.length > 0 &&
          item.status !== "Closed"
        );
      });

      setSuspensionData(sortedData);
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      const sortedData = data.filter((item) => {
        return item.escalation && item.status !== "Closed";
      });

      setEscalationData(sortedData);
    }
  }, [data]);

  useEffect(() => {
    setCurrentSuspensionList(
      getPaginatedList(suspensionData, resultsPerPage, suspensionPage)
    );
  }, [suspensionData, suspensionPage]);

  useEffect(() => {
    setCurrentEscalationList(
      getPaginatedList(escalationData, resultsPerPage, escalationPage)
    );
  }, [escalationData, escalationPage]);

  const handleSuspend = (item) => {
    setSuspendModalOpen(true);
    setIncidentItem(item);
  };

  const handleEscalate = (item) => {
    setEscalatedModalOpen(true);
    setIncidentItem(item);
  };

  async function handleSuspendUser(item) {
    await suspendUser(item);
    setSuspendModalOpen(false);
  }

  return (
    <>
      <div className={styles.container}>
        <h2 className={styles.header}>ESCALATIONS</h2>
        <Card className={styles.cardContainer}>
          <h5 className={styles.title}>Pending Suspension</h5>
          <div className={styles.hr} />

          <div className={styles.headerContainer}>
            <div className={styles.headerItem}>Incident #</div>
            <div className={styles.headerItem}>Status</div>
            <div className={styles.headerItem}>Type</div>
            <div className={styles.headerItem}>Severity</div>
            <div className={styles.headerItem}>IBO #</div>
            <div className={styles.headerItem}>Case Owner</div>
          </div>

          <div className={styles.pendingContainer}>
            {currentSuspensionList &&
              currentSuspensionList.map((suspensionItem, index) => (
                <div key={index}>
                  <PendingSuspensionItem
                    index={index}
                    IncidentDetails={suspensionItem}
                    onSuspendClick={() => handleSuspend(suspensionItem)}
                  />
                </div>
              ))}
          </div>

          {escalationData && escalationData.length <= resultsPerPage ? null : (
            <div className={styles.pageContainer}>
              <PaginationControls
                page={suspensionPage}
                lastPage={suspensionMaxPages}
                onPageChange={(page) => setSuspensionPage(page)}
                disableNext={suspensionPage >= suspensionMaxPages}
                disabled={!currentSuspensionList}
                color="#1F3BD8"
              />
            </div>
          )}
        </Card>

        <Card className={styles.cardContainer}>
          <h5 className={styles.title}>Escalated Incidents</h5>
          <div className={styles.hr} />
          <div className={styles.escalatedGrid}>
            <div className={styles.headerItem}>Incident #</div>
            <div className={styles.headerItem}>Reason</div>
            <div className={styles.headerItem}>Case Owner</div>
            <div className={styles.headerItem}>Actions Needed</div>
          </div>

          <div className={styles.pendingContainer}>
            {currentEscalationList &&
              currentEscalationList.map((escalateItem, index) => (
                <div key={index}>
                  <EscalatedIncidentItem
                    index={index}
                    IncidentDetails={escalateItem}
                    onSuspendClick={() => handleEscalate(escalateItem)}
                  />
                </div>
              ))}
          </div>

          {suspensionData && suspensionData.length <= resultsPerPage ? null : (
            <div className={styles.pageContainer}>
              <PaginationControls
                page={escalationPage}
                lastPage={escalationMaxPages}
                onPageChange={(page) => setEscalationPage(page)}
                disableNext={escalationPage >= escalationMaxPages}
                disabled={!currentEscalationList}
                color="#1F3BD8"
              />
            </div>
          )}
        </Card>

        <SuspendUserModal
          isOpen={suspendModalOpen}
          userInfo={incidentItem}
          onConfirm={handleSuspendUser}
          refetch={refetch}
          onClose={() => {
            setSuspendModalOpen(false);
          }}
        />

        <EscalatedIncidentsModal
          isOpen={escalatedModalOpen}
          userInfo={incidentItem}
          onView={() => {}}
          onClose={() => {
            setEscalatedModalOpen(false);
          }}
        />
      </div>
    </>
  );
}
